import { useSelector } from "react-redux";

export const useConfigurationAsCodeFeatureFlag = () => {
    return useSelector((state: GlobalState) => state.configurationArea.features.isConfigurationAsCodeEnabled);
};

export default useConfigurationAsCodeFeatureFlag;
